import { Box, Divider, Paper, Typography } from "@material-ui/core";
import React from "react";
import "./MiniStatementNotFound.css";

export default function MiniStatementNotFound(props) {
  let accountNo;
  let masked_accountNo;
  // console.log(
  //   "props.miniStatementNotFoundData: ",
  //   props.miniStatementNotFoundData
  // );
  props.miniStatementNotFoundData.map((items, i) => {
    // console.log("Not Found Mini Statement Component Entered: ", items);
    accountNo = items.Body.Payload.Account_No;
    masked_accountNo = accountNo.replace(/\d(?=\d{4})/g, "X");
  });
  let customMessage = `No Transaction/s Found for the Account Number ${masked_accountNo}`;
  return (
    <>
      <div className="msnf-content-wrapper msnf-content-wrapper-bot msnf-content-wrapper-border msnf-width-70" style={{ border: "8px solid rgba(244, 176, 53, 0.8)"}}>
        <Box>
          <Typography align="center" variant="subtitle2" display="block" style={{ color: "rgba(12, 77, 162, 1)", fontSize: "20px" ,textAlign:"center",fontWeight:"600"}}>
            Mini Statement
          </Typography>
        </Box>
        <Divider variant="middle" />
        <Box className="box-message">
          <Typography align="center" component="subtitle1">
            {customMessage}
          </Typography>
        </Box>
      </div>
    </>
  );
}
